import { render } from "./SkipNavigation.vue?vue&type=template&id=ed77f052"
import script from "./SkipNavigation.vue?vue&type=script&lang=js"
export * from "./SkipNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__